'use strict';
/* COMPONENT - c.05.05 - Event ticket list */

export default class EventTicketList {

    constructor(element) {
        this.root = element;
        this.form = this.root.querySelector('form');
        this.errorWrapper = this.form.querySelector('.event-ticket-form-feedback');
        this.bindEvents();
    }

    submitForm(form) {
        event.preventDefault();

        let selectInputs = form.querySelectorAll('select'),
            selectCount = 0;
        for (let i = 0; i < selectInputs.length; i++) {
            let selectOption = parseInt(selectInputs[i].value);
            selectCount += selectOption;
        }
        if (selectCount === 0 || undefined) {
            this.errorWrapper.innerHTML = '<p id="event-ticket-error">Please select a ticket option</p>';
            //focus on the first select input if there is an error
            selectInputs[0].focus();
        } else {
            form.submit();
        }
    }

    bindEvents() {
        this.form.addEventListener('submit', this.submitForm.bind(this, this.form));
    }
}
